import React, { Component } from 'react'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from  '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles'
import { getChronicConditions, getCancerTypes, getCancerStages, getEthnicities, updatePatient, getPatient } from '../api'
import isValidZip from 'is-valid-zip'
import { AsYouType } from 'libphonenumber-js';
const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance()

const styles = theme => ({
  page: {
    height: 'calc(100% - 120px)',
    width: '100%',
    overflow: 'scroll',
    padding: 40
  },
  header: {
    fontSize: '1.5rem',
  },
  paper: {
    marginBottom: 20,
    boxShadow: 'none'
  },
  flex: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginRight: 50,
    marginBottom: 20
  },
  input: {
    width: 325,
    marginRight: 20
  },
  error: {
    color: 'red'
  },
  button: {
    marginTop: 20
  }
})

class Personal extends Component {
  constructor (props) {
    super(props)

    this.phoneNumberFormatters = {
      phoneNumber: new AsYouType('US'),
      emergency_contact_phone_number: new AsYouType('US')
    }

    this.state = {
      editing: false,
      patientInfo: Object.assign(
        {},
        props.patient,
        {
          phoneNumber: this.phoneNumberFormatters.phoneNumber.input(props.patient.phoneNumber),
          emergency_contact_phone_number: this.phoneNumberFormatters.emergency_contact_phone_number.input(props.patient.emergency_contact_phone_number)
        }
      ),
      errors: {},
      editable: false,
      cancerTypes: [],
      chronicConditions: [],
      cancerStages: [],
      ethnicities: []
    }
  }

  componentDidMount () {
    const { id } = this.state.patientInfo

    Promise.all([getCancerTypes(), getChronicConditions(), getCancerStages(), getEthnicities(), getPatient(id)]).then(response => {
      this.setState({
        cancerTypes: response[0].sort((a,b) => a.name <= b.name ? -1 : 1),
        chronicConditions: response[1].sort((a,b) => a.name <= b.name ? -1 : 1),
        cancerStages: response[2],
        ethnicities: response[3].sort((a,b) => a.name <= b.name ? -1 : 1),
        patientInfo: response[4],
        editable: true,
      })
    })
  }

  validateEmail (email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  validatePhone (number) {
    try {
      return phoneUtil.isValidNumber(phoneUtil.parse(number, 'US'))
    } catch (error) {
      return false
    }
  }

  validate (fieldName, value) {
    switch (fieldName) {
      case 'email':
        return this.validateEmail(value)
          ? null
          : 'Not a valid email. Please use format username@domain.com (.org, .edu, etc.).'
      case 'zipCode':
        return isValidZip(value)
        ? null
        : 'Not a valid zip code. Please enter a five-digit number.'
      case 'phoneNumber':
        return this.validatePhone(value)
          ? null
          : 'Not a valid phone number.'
      case 'emergency_contact_phone_number':
        return this.validatePhone(value)
          ? null
          : 'Not a valid phone number.'
      default:
        return null;
    }
  }

  handleChange (e, fieldName, preprocess = (key, val) => val) {
    const value = preprocess(fieldName, e.target.value)
    const info = Object.assign({}, this.state.patientInfo, { [fieldName]: value })
    const error = this.validate(fieldName, e.target.value)

    let errors
    if (error) {
      errors = Object.assign({}, this.state.errors, { [fieldName]:  error})
    } else {
      errors = Object.assign({}, this.state.errors)
      delete errors[fieldName]
    }
    this.setState({ patientInfo : info, errors })
  }

  handleSave = (e) => {
    updatePatient(this.state.patientInfo.id, Object.assign({}, this.state.patientInfo))
      .then(response => this.setState({patientInfo: response}))
  }

  preprocessPhoneNumber = (fieldName, value) => {
    this.phoneNumberFormatters[fieldName] = new AsYouType('US')
    return this.phoneNumberFormatters[fieldName].input(value)
  }

  render() {
    const { classes } = this.props
    const {
      patientInfo,
      cancerTypes,
      chronicConditions,
      cancerStages,
      ethnicities,
      errors
    } = this.state

    return (
      <div className={classes.page}>
        <Typography className={classes.header}>Personal Information</Typography>
        <Paper className={classes.paper}>
          <TextField
            className={classes.input}
            label="First Name"
            placeholder="First Name"
            value={patientInfo.firstName}
            onChange={e => this.handleChange(e, 'firstName')}
          />
          <TextField
            className={classes.input}
            label="Last Name"
            placeholder="Last Name"
            value={patientInfo.lastName}
            onChange={e => this.handleChange(e, 'lastName')}
          />
        </Paper>
        <Paper className={classes.paper}>
          <FormControl>
            <TextField
              className={classes.input}
              label="Email Address"
              placeholder="Email Address"
              value={patientInfo.email}
              onChange={e => this.handleChange(e, 'email')}
              error={!!errors.email}
            />
            {errors.email && <FormHelperText className={classes.error}>{errors.email}</FormHelperText>}
          </FormControl>
        </Paper>
        <Paper className={classes.paper}>
          <FormControl>
            <TextField
              className={classes.input}
              label="Phone Number"
              placeholder="Phone Number"
              value={patientInfo.phoneNumber}
              onChange={e => this.handleChange(e, 'phoneNumber', this.preprocessPhoneNumber)}
              error={!!errors.phoneNumber}
            />
            {errors.phoneNumber && <FormHelperText className={classes.error}>{errors.phoneNumber}</FormHelperText>}
          </FormControl>
        </Paper>
        <Paper className={classes.paper}>
          <FormControl>
            <TextField
              className={classes.input}
              label="Zipcode"
              placeholder="Zipcode"
              value={patientInfo.zipCode}
              onChange={e => this.handleChange(e, 'zipCode')}
              error={!!errors.zipCode}
            />
            {errors.zipCode && <FormHelperText className={classes.error}>{errors.zipCode}</FormHelperText>}
          </FormControl>
        </Paper>
        <Paper className={classes.paper}>
          <FormControl className={classes.input}>
            <InputLabel>Age</InputLabel>
            <Select
              value={patientInfo.age}
              onChange={e => this.handleChange(e, 'age')}
            >
              {
                Array(110).fill().map((_, i) => (
                  <MenuItem value={i} key={i}>{i}</MenuItem>
                ))
              }
            </Select>
          </FormControl>
          <FormControl className={classes.input}>
            <InputLabel>Sex</InputLabel>
            <Select
              value={patientInfo.sex}
              onChange={e => this.handleChange(e, 'sex')}
            >
                <MenuItem value="M">M</MenuItem>
                <MenuItem value="F">F</MenuItem>
                <MenuItem value="O">Other</MenuItem>
            </Select>
          </FormControl>
        </Paper>
        <Paper className={classes.paper}>
          <FormControl className={classes.input}>
            <InputLabel>Ethnicity</InputLabel>
            <Select
              value={patientInfo.ethnicity_id}
              onChange={e => this.handleChange(e, 'ethnicity_id')}
            >
              { ethnicities.map(ethnicity => <MenuItem value={ethnicity.id}>{ethnicity.name}</MenuItem>) }
            </Select>
          </FormControl>
        </Paper>
        <Typography className={classes.header}>Emergency Contact</Typography>
        <Paper className={classes.paper}>
          <TextField
            className={classes.input}
            label="Emergency Contact Name"
            placeholder="Emergency Contact Name"
            value={patientInfo.emergency_contact_name}
            onChange={e => this.handleChange(e, 'emergency_contact_name')}
          />
          <FormControl>
            <TextField
              className={classes.input}
              label="Emergency Contact Phone Number"
              placeholder="Emergency Contact Phone Number"
              value={patientInfo.emergency_contact_phone_number}
              onChange={e => this.handleChange(e, 'emergency_contact_phone_number', this.preprocessPhoneNumber)}
              error={!!errors.emergency_contact_phone_number}
            />
            <FormHelperText className={classes.error}>{errors.emergency_contact_phone_number}</FormHelperText>
          </FormControl>
        </Paper>
        <Typography className={classes.header}>Diagnosis and Care</Typography>
        <Paper className={classes.paper}>
          <FormControl className={classes.input}>
            <InputLabel>Cancer Type</InputLabel>
            <Select
              value={patientInfo.cancer_type_id || ''}
              onChange={e => this.handleChange(e, 'cancer_type_id')}
            >
              { cancerTypes.map(type => <MenuItem value={type.id}>{type.name}</MenuItem>) }
            </Select>
          </FormControl>
          <FormControl className={classes.input}>
            <InputLabel>Disease Stage</InputLabel>
            <Select
              value={patientInfo.cancer_stage_id || ''}
              onChange={e => this.handleChange(e, 'cancer_stage_id')}
            >
              { cancerStages.map(stage => <MenuItem value={stage.id}>{stage.name}</MenuItem>) }
            </Select>
          </FormControl>
        </Paper>
        <Paper className={classes.paper}>
          <FormControl className={classes.input}>
            <InputLabel>Chronic Conditions</InputLabel>
            <Select
              value={patientInfo.chronic_condition_id || ''}
              onChange={e => this.handleChange(e, 'chronic_condition_id')}
            >
              { chronicConditions.map(type => <MenuItem value={type.id}>{type.name}</MenuItem>) }
            </Select>
          </FormControl>
          <TextField
            className={classes.input}
            label="Treatment Center"
            placeholder="Treatment Center"
            value={patientInfo.treatmentCenter || ''}
            onChange={e => this.handleChange(e, 'treatmentCenter')}
          />
        </Paper>
        <Button
          className={classes.button}
          variant="contained"
          color="primary"
          onClick={this.handleSave}
          disabled={Object.keys(this.state.errors).length > 0}
        >
          Save
        </Button>
      </div>
    )
  }
}

export default withStyles(styles)(Personal)



// WEBPACK FOOTER //
// ./src/pages/Personal.js